import { useEffect, useState } from "react";

function useWatchLoaclstorageValue<T>({ initValue, key }: { initValue: T; key: string }) {
  const [data, setData] = useState<T>(initValue);

  const initData = () => {
    const value = localStorage.getItem(key);
    setData(value as T);
  };

  // 更新 localStorage 并同步触发当前页面监听
  const updateLocalStorage = (value: string) => {
    localStorage.setItem(key, value as string);
    window.dispatchEvent(new Event("localStorageChange")); // 触发当前页面同步
  };

  // 进入页面更新一下
  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // 监听跨标签页的 localStorage 变化
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === key) {
        setData(event.newValue as T);
      }
    };

    // 监听当前页面的自定义 localStorage 事件
    const handleLocalChange = () => {
      initData();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("localStorageChange", handleLocalChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("localStorageChange", handleLocalChange);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { updateLocalStorage, value: data };
}

export default useWatchLoaclstorageValue;
